import {moneyFormatter, moneyFormatterCents} from "../../lib/formatters";
import {Input} from "../ui/input";

/**
 * Parses a USD-formatted string back into a number.
 * Intl.NumberFormat doesn't provide a parse API, so strip symbols manually.
 *
 * @param {string} str e.g. "$1,234" or "$1,234.56"
 * @returns {number}
 */
export function USDonChange(value: string) {
    if (value === "") {
        return "";
    }
    // const cents = Math.round((amount - Math.trunc(amount)) * 100);
    // const rawValue = value.replace(/[^0-9.]/g, '');
    const rawValue = value.replace(/[$,]/g, "");
    const parsedValue = parseFloat(rawValue);

    if (!isNaN(parsedValue)) {
        return parsedValue.toString();
    } else {
        return ""
    }
}

export function NumClean(value: string){
    return  value.replace(/[^0-9.,]/g, "");
}

/**
 * like USDonChange, but keeps a decimal that is being typed - parseFloat would drop "1234." / "1234.0".
 * "$1,234.567" -> "1234.56". use with USDtoValueCents.
 */
export function USDonChangeCents(value: string) {
    const m = value.trim().replace(/[$,]/g, "").match(/^\d*(\.\d{0,2})?/);
    return m ? m[0] : "";
}

export function USDtoValueCell(amount: any) {
    // console.log(amount);
    if (amount) {
        // Detect whether there's any non-zero cents
        const cents = Math.round((amount - Math.trunc(amount)) * 100);
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: cents ? 2 : 0,
            maximumFractionDigits: 2,
        });

        return formatter.format(amount);
    }
    return "";
}


export function USDtoValue(value: any) {
    if (value) {
        //console.log(value);
        return moneyFormatterCents.format(Number(value))
    }
    return "";
}

/**
 * dollars formatted, cents as typed: "1234." -> "$1,234."  "1234.05" -> "$1,234.05"
 */
export function USDtoValueCents(value: any) {
    if (!value) {
        return "";
    }
    const [dollars, cents] = String(value).split(".");
    const text = moneyFormatter.format(Number(dollars));
    return cents === undefined ? text : `${text}.${cents}`;
}

